<template>
    <div>
      <v-main>
        <v-overlay v-if="loading">
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-overlay>
        <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
          <v-row>
            <v-col>
               <v-breadcrumbs :items="breadcrumbs" id="v-step-4"></v-breadcrumbs>
            </v-col>
          </v-row>
          <v-row >
            <v-col>
                <v-select
                    v-model="selectEx"
                    :items="itemsEx"
                    label="บริการ"
                    dense
                    outlined
                    @change="getDataFilter()"
                ></v-select>
            </v-col>
            <v-col>
                <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="date"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              label="ค้นหาตามวันที่"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
              clearable
              @click:clear="clearTextField()"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            no-title
            scrollable
            range
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="menu = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.menu.save(date), getDataFilter()"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
            </v-col>
            <!-- <v-col>
              <v-text-field
              v-model="searchTel"
                placeholder="เบอร์โทรศัพท์"
                solo
                dense
                type="number"
                @keyup="search(item)"
            ></v-text-field>
            </v-col> -->
        </v-row>
           <v-data-table
            :headers="headers"
            :items="desserts"
            :items-per-page="5"
            class="elevation-1"
        >
             <template v-slot:[`item.img_slip`]="{ item }">
                <v-btn
                dark
                rounded
                color="#757575"
                @click="openImg(item)"
                >ดูรูป<v-icon size="20">mdi-receipt</v-icon></v-btn>
            </template>
           <template v-slot:[`item.exchangrateId`]="{ item }">
               <v-select
               v-model="item.exchangrateId"
                :items="itemsEx"
                solo
                @change="updateEx(item)"
                hide-details
                dense
                ></v-select>
            </template>
            <template v-slot:[`item.masBranchID`]="{ item }">
              <v-select
               v-model="item.masBranchID"
                :items="branch"
                item-text="masBranchName"
                item-value="masBranchID"
                placeholder="เลือกสาขา"
                solo
                hide-details
                dense
                ></v-select>
            </template>
            <template  v-slot:[`item.glutenfree`]="{ item }">
            <v-text-field
                style="display:flex;align-items:center"
                v-model="item.glutenfree"
                placeholder="ยอดค่าใช้จ่าย"
                outlined
                dense
                @input="cal_coin(item)"
                hide-details
            ></v-text-field>
            </template>
            <template v-slot:[`item.total_coin`]="{ item }">
              <p style="margin: 0;">{{item.glutenfree ? formatNumber(item.total_coin) : 0 }} คะแนน</p>
              <p v-if="item.mutiplyStatus" class="mb-0 blink_me" style="border: solid;border-radius: 50px;font-size: 11px;color: green;padding: 1px 5px;">{{item.mutiplyStatus}}</p>
            </template>
            <template v-slot:[`item.note`]="{ item }">
            <v-text-field
              v-model="item.note"
                placeholder="หมายเหตุ"
                outlined
                dense
                hide-details
            ></v-text-field>
            </template>
            <template v-slot:[`item.action`]="{ item }">
                <v-btn
                    class="btn-color"
                    dark
                    color="#1c437c"
                    id="v-step-2"
                    small
                    rounded
                    :disabled="item.grute"
                    block
                    @click.stop="update(item)"
                >
                เพิ่มพอยท์
                </v-btn>
                <v-btn
                    class="btn-color"
                    dark
                    color="#bfbfbf"
                    id="v-step-2"
                    small
                    rounded
                    block
                    @click.stop="reject(item)"
                >
                ยกเลิก
                </v-btn>
                </template>
        </v-data-table>
        <!-- openIMG -->
        <v-dialog
      v-model="dialog"
      width="400"
      style=""
    >

      <v-card >
        <v-container>
        <div class="text-right">
          <v-btn
      class="mx-2"
      fab
      dark
      small
      color="grey lighten-1"
    >
      <v-icon dark @click="dialog=false">
        mdi-close
      </v-icon>
    </v-btn>
        </div>
        <div style="display:flex;align-items:center;justify-content:center;margin-top: 10px;">
            <image-zoom
            :regular="imgOpen"
            :zoom="imgOpen"
            :zoom-amount="2.5"
            img-class="img-fluid"
            alt="Sky"
            @on-zoom="zoom = true"
            @off-zoom="zoom = false"
                >
            </image-zoom>
        </div>
        <!-- <image-zoom
          :regular="imgOpen"
          :zoom="imgOpen"
         >
          <v-img :src="imgOpen"  style="height:400px"/>
        </image-zoom> -->
        </v-container>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <!-- openIMG -->
        </div>
      </v-main>

    </div>
</template>

<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date
import imageZoom from 'vue-image-zoomer'

export default {
  name: 'LoyaltySystemAddPoint',
  components: {
    imageZoom
  },
  data () {
    return {
      breadcrumbs: [
        {
          // 0962525196
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ให้คะแนนจาก slip',
          disabled: false,
          href: '/addcoin/slip'
        }
      ],
      session: this.$session.getAll(),
      headers: [
        {text: 'ชื่อ', value: 'name'},
        {text: 'เบอร์โทรศัพท์', value: 'tel', width: '150px'},
        {text: 'slip', value: 'img_slip', width: '50px'},
        {text: 'บริการ', value: 'exchangrateId', align: 'center', width: '150px'},
        {text: 'สาขา', value: 'masBranchID', align: 'center', width: '150px'},
        {text: 'ยอดใช้จ่าย', value: 'glutenfree', align: 'center', width: '150px'},
        {text: 'เพิ่มคะแนน', value: 'total_coin', align: 'center', width: '90px'},
        {text: 'หมายเหตุ', value: 'note', align: 'center', sortable: false, width: '150px'},
        {text: 'วันที่ทำรายการ', value: 'CREATE_DATE'},
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center', width: '250px' }
      ],
      desserts: [],
      itemsEx: [],
      total_coin: 0,
      dialog: false,
      imgOpen: null,
      i: 0,
      selectEx: '',
      date: [],
      menu: false,
      searchTel: '',
      zoom: false,
      dataExchange: [],
      loading: false,
      branch: []
    }
  },
  computed: {
    dateRangeText () {
      return this.date.join(' - ')
    }
  },
  async mounted () {
    await this.getBranch()
    console.log('okok', this.session.data.userId)
    this.cal_coin(this.i)
    this.getdata()
    this.getDataExchang()
  },

  methods: {
    // formatCurrency () {
    //   const number = parseFloat(this.test.replace(/,/g, ''));
    //   if (!isNaN(number)) {
    //     this.test = number.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //   }
    // },
    // removeFormatting () {
    //   const number = parseFloat(this.test.replace(/,/g, ''))
    //   if (!isNaN(number)) {
    //     this.test = number.toString()
    //   }
    // },
    zoomIn () {
      this.zoomLevel += 0.1
    },
    zoomOut () {
      this.zoomLevel -= 0.1
      if (this.zoomLevel < 1) {
        this.zoomLevel = 1
      }
    },
    getdata () {
      axios
        .get(this.DNS_IP + '/AddCoin/get?shopId=' + this.session.data.shopId + '&status=waiting')
        .then(res => {
          if (res.data.message === 'No data found') {
            this.desserts = []
          } else {
            this.desserts = res.data
            console.log(this.desserts)
            this.desserts.map(el => {
              if (el.multiplyPoint) {
                let startDate = new Date(el.startMultiplyPoint).setHours(0, 0, 0, 0)
                let endDate = new Date(el.endMultiplyPoint).setHours(0, 0, 0, 0)
                var todaysDate = new Date().setHours(0, 0, 0, 0)
                console.log(todaysDate)
                console.log(startDate)
                console.log(endDate)
                if (startDate <= todaysDate && endDate >= todaysDate) {
                  el.mutiplyStatus = 'คะแนน x' + el.multiplyPoint
                }
              }
            })
            if (this.branch.length === 1) {
              this.desserts.map((item) => {
                item.masBranchID = this.branch[0].masBranchID
              })
              console.log('length', this.desserts)
            }
          }
        })
    },
    update (item) {
      this.loading = true
      console.log('item', item)
      this.$swal({
        title: 'ต้องการเพิ่มคะแนน?',
        icon: 'success', // หรือ 'type' ถ้าใช้ SweetAlert เวอร์ชันเก่า
        showCancelButton: true,
        confirmButtonColor: '#1b437c',
        cancelButtonColor: '#da484f',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      }).then((result) => {
        if (result) {
          var data = {
            id: item.id,
            refId: item.note,
            shopId: this.$session.getAll().data.shopId,
            tel: item.tel,
            Amount: item.glutenfree,
            exchangRateId: item.exchangrateId,
            masBranchID: this.session.data.masBranchID,
            source: false,
            status: 'comfirm',
            employee: this.session.data.displayName,
            branchName: this.session.data.branchName,
            userId: this.session.data.userId,
            DATE_UPLOAD: item.DATE_UPLOAD,
            id_addcoin: item.id
          }

          console.log('dataItem', data)
          axios.post(this.DNS_IP + '/POSapi', data).then((response) => {
            console.log('POSapi"', response)
            if (response.data.status === true) {
              this.$swal('เรียบร้อย', 'เพิ่มเหรียญเรียบร้อย', 'success')
            } else {
              this.$swal('แจกคะแนนไม่สำเร็จ', 'แจกคะแนนไม่สำเร็จกรุณาแจ้งพนักงาน', 'error')
            }
            this.loading = false
            this.getdata()
          }).catch(() => {
            this.loading = false
          })
        } else {
          this.loading = false // ✅ เพิ่มตรงนี้สำหรับกรณีกดยกเลิก
        }
      }).catch((err) => {
        console.log('err', err)
        this.loading = false // fallback เผื่อมี error อื่น
      })
    },
    getDataExchang () {
      axios
        .get(this.DNS_IP + '/productExchangeRate/get?shopId=' + this.session.data.shopId)
        .then(res => {
          res.data.map(el => {
            var s = {}
            s.value = el.productExchangeRateId.toString()
            s.text = el.name
            s.exchangeRate = el.exchangeRate
            this.itemsEx.push(s)
            this.dataExchange.push(el)
          })
        })
    },
    async cal_coin (item) {
      // exchangrateId
      let multiply = this.dataExchange.filter(item2 => item2.productExchangeRateId.toString() === item.exchangrateId)[0]

      if (item.glutenfree === '0' || item.glutenfree === '' || !item.glutenfree) {
        this.desserts.map(el => {
          if (el.id === item.id) {
            el.total_coin = 0
          }
        })
      } else {
        this.desserts.map(el => {
          if (el.id === item.id) {
            if (multiply.multiplyPoint) {
              console.log('ddddddd')
              let startDate = new Date(multiply.startMultiplyPoint).setHours(0, 0, 0, 0)
              let endDate = new Date(multiply.endMultiplyPoint).setHours(0, 0, 0, 0)
              var todaysDate = new Date().setHours(0, 0, 0, 0)
              if (startDate <= todaysDate && endDate >= todaysDate) {
                console.log('คูณคะแนน')
                el.total_coin = Math.floor(item.glutenfree / item.exchangeRate) * multiply.multiplyPoint
                // el.mutiplyStatus = 'คะแนน x' + multiply.multiplyPoint
              } else {
                el.total_coin = Math.floor(item.glutenfree / item.exchangeRate)
              }
            } else {
              el.total_coin = Math.floor(item.glutenfree / item.exchangeRate)
            }
          }
        })
      }
      if (this.branch.length === 1) {
        this.desserts.map((item) => {
          item.masBranchID = this.branch[0].masBranchID
        })
      }
      console.log(this.desserts)
    },
    openImg (item) {
      this.dialog = true
      this.imgOpen = item.img_slip
    },
    updateEx (item) {
      console.log('productExchangeRateId', this.itemsEx)
      console.log('item', item)
      if (item) {
        this.itemsEx.map(el => {
          if (el.value === item.exchangrateId) {
            const index = this.desserts.findIndex((dessert) => dessert.id === item.id)
            if (index !== -1) {
              // Update the exchangrateId property of the found item
              this.desserts[index].exchangrateId = el.value
              this.desserts[index].exchangeRate = el.exchangeRate
              this.desserts[index].exchangeRateName = el.text
              delete this.desserts[index].glutenfree
              let multiply = this.dataExchange.filter(item2 => item2.productExchangeRateId.toString() === item.exchangrateId)[0]
              if (multiply.multiplyPoint) {
                let startDate = new Date(multiply.startMultiplyPoint).setHours(0, 0, 0, 0)
                let endDate = new Date(multiply.endMultiplyPoint).setHours(0, 0, 0, 0)
                var todaysDate = new Date().setHours(0, 0, 0, 0)
                if (startDate <= todaysDate && endDate >= todaysDate) {
                  this.desserts[index].mutiplyStatus = 'คะแนน x' + multiply.multiplyPoint
                  this.desserts[index].multiplyPoint = multiply.multiplyPoint
                  this.desserts[index].startMultiplyPoint = multiply.startMultiplyPoint
                  this.desserts[index].endMultiplyPoint = multiply.endMultiplyPoint
                // el.mutiplyStatus = 'คะแนน x' + multiply.multiplyPoint
                }
              } else {
                delete this.desserts[index].mutiplyStatus
              }
              // let startDate = new Date(multiply.startMultiplyPoint).getTime()
              // let endDate = new Date(multiply.endMultiplyPoint).getTime()
              // var todaysDate = new Date().getTime()
              // if (multiply.multiplyPoint) {
              //   if (startDate <= todaysDate && endDate > todaysDate) {
              //     el.mutiplyStatus = 'คะแนน x' + el.multiplyPoint
              //   // el.mutiplyStatus = 'คะแนน x' + multiply.multiplyPoint
              //   } else {
              //     if (this.desserts[0].mutiplyStatus) {
              //       delete this.desserts[0].mutiplyStatus
              //     }
              //   }
              // }
            }
            console.log('index', this.desserts)
            console.log('index', index)
          }
        })
      }
    },
    reject (item) {
      console.log(item)
      this.$swal({
        title: 'ต้องการยกเลิก?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1b437c',
        cancelButtonColor: '#da484f',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        closeOnConfirm: false
      }).then((response) => {
        var data = {
          id: item.id,
          status: 'reject',
          shopId: this.$session.getAll().data.shopId,
          tel: item.tel,
          note: item.note,
          refId: item.note,
          exchangeRateName: item.exchangeRateName,
          masBranchID: this.session.data.masBranchID,
          branchName: this.session.data.branchName,
          exchangRateId: item.exchangrateId,
          employee: this.session.data.displayName

        }
        axios.post(this.DNS_IP + '/reject', data).then((response) => {
          this.$swal('เรียบร้อย', 'ยกเลิกสำเร็จ', 'success')
          this.getdata()
        })
      })``
    },
    clearTextField () {
      this.date = []
      this.getDataFilter()
    },
    async getBranch () {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_branch/get?shopId=' + this.$session.getAll().data.shopId
        )
        .then(async response => {
          this.branch = response.data
          console.log('this.branch', this.branch)
          // this.belinkBranch
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log('error function getBranch : ', error)
        })
    },
    getDataFilter () {
      this.desserts = []
      if (this.selectEx !== '' && this.date.length > 0) {
        axios
          .get(this.DNS_IP + '/AddCoin/get?shopId=' + this.session.data.shopId + '&exchang=' + this.selectEx + '&CREATE_DATE=' + this.date + '&status=waiting')
          .then(res => {
            if (res.data.message === 'No data found') {
              this.desserts = []
            } else {
              console.log('resdataBran1', res.data)
              this.desserts = res.data
              this.export_data = res.data
            }
          })
      } else if (this.selectEx === '' && this.date.length > 0) {
        this.date.sort((date1, date2) => moment(date1).diff(moment(date2)))
        axios
          .get(this.DNS_IP + '/AddCoin/get?shopId=' + this.session.data.shopId + '&CREATE_DATE=' + this.date + '&status=waiting')
          .then(res => {
            if (res.data.message === 'No data found') {
              this.desserts = []
            } else {
              console.log('resdataBran2', res.data)
              this.desserts = res.data
              this.export_data = res.data
            }
          })
      } else if (this.selectEx !== '' && this.date.length <= 0) {
        axios
          // .get(this.DNS_IP + '/qrcode/get?shopId=' + this.session.data.shopId + '&masBranchID=' + this.selectBranch + '&statusin="used","reject"')
          .get(this.DNS_IP + '/AddCoin/get?shopId=' + this.session.data.shopId + '&exchang=' + this.selectEx + '&status=waiting')
          .then(res => {
            if (res.data.message === 'No data found') {
              this.desserts = []
            } else {
              console.log('resdataBran3', res.data)
              this.desserts = res.data
              this.export_data = res.data
            }
          })
      } else if (this.selectEx === '' && this.date.length <= 0) {
        axios
          .get(this.DNS_IP + '/AddCoin/get?shopId=' + this.session.data.shopId + '&LAST_DATE=' + this.date + '&status=waiting')
          .then(res => {
            if (res.data.message === 'No data found') {
              this.desserts = []
            } else {
              console.log('resdataBran4', res.data)
              this.desserts = res.data
              this.export_data = this.desserts
              this.desserts.map(el => { if (el.status === 'reject') { el.status = 'ทำรายการไม่สำเร็จ' } else if (el.status === 'used') { el.status = 'ทำรายการสำเร็จ' } else {} })
              console.log('ex', this.export_data)
            }
          })
      }
    },
    search () {

    }
  }
}
</script>

<style scoped>
.v-data-table >>> div > table {
 height: 100px
}
</style>



// WEBPACK FOOTER //
// src/components/Master/addpoint.vue